import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";

import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import moment from "moment";
import {Card, CardContent} from "@material-ui/core";
import CollectionOverride from "components/CollectionOverride";



export default class DavidsonsCompleted extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Acquisitions_Pendings._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_DAVIDSONS_HISTORY';

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "From Dealer",
				id: "ffl_name",
				/** @param {Acquisitions_Pendings_Object} obj */
				accessor: obj => (obj.ffl_name + ' (' + obj.ffl_number + ')')
			},
			{
				Header: "To FFL",
				id: "location",
				/** @param {Acquisitions_Pendings_Object} obj */
				accessor: obj => (obj.locations.name)
			},
			{
				Header: "Date",
				id: "date",
				width: 100,
				/** @param {Acquisitions_Pendings_Object} obj */
				accessor: obj => {
					return obj.date ? moment(obj.date).local().format("MM/DD/YYYY") : '-'
				}
			},
			{
				Header: "Number of Products",
				id: "count",
				/** @param {Acquisitions_Pendings_Object} obj */
				accessor: obj => (obj.count ?? 'No Count Available')
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 70,
				Cell: props => {
					return (
						<span>
							<Link to={`/acquisitions/pendings/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									Review</Button>
							</Link>
						</span>
					);
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('In-Network Transfers')}
							{this.renderHeaderRight("In-Network Transfers", columns)}

						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
